import { Navigate } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import MyLogPage from "@/pages/MyLogPage";
import MyPayslipPage from "@/pages/MyPayslipPage";
import BranchesPage from "@/pages/BranchesPage";
import BranchDetailPage from "@/pages/BranchDetailPage";
import DepartmentsPage from "@/pages/DepartmentsPage";
import EmployeesPage from "@/pages/EmployeesPage";
import EmployeeDetailPage from "@/pages/EmployeeDetailPage";
import RequestsPage from "@/pages/RequestsPage";
import ReportsPage from "@/pages/ReportsPage";
import ApiAccessPage from "@/pages/ApiAccessPage";
import SettingsPage from "@/pages/SettingsPage";
import MorePage from "@/pages/MorePage";
import BillingPage from "@/pages/BillingPage";
import WalletPage from "@/pages/WalletPage";
import MyRequestsPage from "@/pages/MyRequestsPage";
import ResignationPage from "@/pages/ResignationPage";
import PayrollPage from "@/pages/PayrollPage";
import DocumentsPage from "@/pages/DocumentsPage";
import DutiesPage from "@/pages/DutiesPage";
import LiveMapPage from "@/pages/LiveMapPage";
import TodayAttendancePage from "@/pages/TodayAttendancePage";
import PenaltiesPage from "@/pages/PenaltiesPage";
import TasksPage from "@/pages/TasksPage";
import MyPerformancePage from "@/pages/MyPerformancePage";
import KpiPage from "@/pages/KpiPage";
import BonusesPage from "@/pages/BonusesPage";
import MyBonusesPage from "@/pages/MyBonusesPage";
import MyBillSignPage from "@/pages/MyBillSignPage";
import PermissionsPage from "@/pages/PermissionsPage";
import BackupPage from "@/pages/BackupPage";
import CompanyNotifyPage from "@/pages/CompanyNotifyPage";
import { FeatureGate } from "@/components/layout/FeatureGate";
import { ADMIN_ROLES, MANAGER_ROLES } from "@/utils/role";

const MANAGERS = MANAGER_ROLES;
const EDITORS = ADMIN_ROLES;

export const APP_ROUTES = [
  { path: "/", element: <HomePage /> },
  { path: "/my-log", element: <MyLogPage /> },
  { path: "/tasks", element: <TasksPage /> },
  { path: "/my-performance", element: <MyPerformancePage /> },
  { path: "/my-payslip", element: <MyPayslipPage /> },
  { path: "/dashboard", element: <Navigate to="/" replace />, roles: MANAGERS },
  { path: "/today", element: <TodayAttendancePage />, roles: MANAGERS },
  { path: "/branches", element: <BranchesPage />, roles: EDITORS },
  { path: "/branches/:id", element: <BranchDetailPage />, roles: EDITORS },
  { path: "/departments", element: <DepartmentsPage />, roles: EDITORS },
  { path: "/employees", element: <EmployeesPage />, roles: MANAGERS },
  { path: "/employees/:id", element: <EmployeeDetailPage />, roles: MANAGERS },
  { path: "/documents", element: <DocumentsPage />, roles: EDITORS },
  { path: "/requests", element: <RequestsPage />, roles: EDITORS },
  { path: "/duties", element: <FeatureGate feature="duties"><DutiesPage /></FeatureGate>, roles: MANAGERS },
  { path: "/live-map", element: <FeatureGate feature="live_map"><LiveMapPage /></FeatureGate>, roles: MANAGERS },
  { path: "/penalties", element: <FeatureGate feature="penalties"><PenaltiesPage /></FeatureGate>, roles: MANAGERS },
  { path: "/kpi", element: <FeatureGate feature="kpi"><KpiPage /></FeatureGate>, roles: MANAGERS },
  { path: "/bonuses", element: <FeatureGate feature="bonuses"><BonusesPage /></FeatureGate>, roles: MANAGERS },
  { path: "/my-bonuses", element: <FeatureGate feature="bonuses"><MyBonusesPage /></FeatureGate> },
  { path: "/inbox/bill/:id", element: <MyBillSignPage /> },
  { path: "/reports", element: <ReportsPage />, roles: MANAGERS },
  { path: "/integrations", element: <FeatureGate feature="api_webhooks"><ApiAccessPage /></FeatureGate>, roles: EDITORS },
  { path: "/billing", element: <BillingPage />, roles: EDITORS },
  { path: "/wallet", element: <WalletPage />, roles: MANAGERS },
  { path: "/my-requests", element: <MyRequestsPage /> },
  { path: "/resignation", element: <ResignationPage /> },
  { path: "/payroll", element: <PayrollPage />, roles: EDITORS },
  { path: "/permissions", element: <PermissionsPage />, roles: EDITORS },
  { path: "/backup", element: <FeatureGate feature="company_backup"><BackupPage /></FeatureGate>, roles: EDITORS },
  { path: "/company-notify", element: <FeatureGate feature="company_broadcast"><CompanyNotifyPage /></FeatureGate>, roles: MANAGERS },
  { path: "/settings", element: <SettingsPage /> },
  { path: "/more", element: <MorePage /> },
];
